module.exports = __webpack_public_path__ + "media/flags/tm-aebbec68.svg";